import { computed } from '@angular/core';
import {
  withCategoriesList,
  withCategoryCreate,
} from '@libs/mtjr/shared/generated/entities/category/category-store-features';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

export const CategoryStore = signalStore(
  withCategoriesList(),
  withCategoryCreate(),
  withState({ query: '' }),
  withMethods((store) => ({
    updateQuery(event: CustomEvent) {
      patchState(store, { query: event.detail.value });
    },
  })),
  withComputed((store) => ({
    canCreateFromQuery: computed(() => {
      const query = store.query().toLocaleLowerCase();
      return query.length > 0 && store.categories().find((it) => it.name.toLocaleLowerCase() === query) == null;
    }),
    filteredOptions: computed(() => {
      const query = store.query();
      const allOptions = store.categories();
      if (query == null || query.length == 0) {
        return allOptions;
      } else {
        return allOptions.filter((it) => it.name.toLowerCase().includes(query.toLowerCase()));
      }
    }),
  })),
);
